var React = require('react');

function YoutubeInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"20","fill":"#3BBB81","key":0}),React.createElement("path",{"d":"M28.6291 15.0342C28.4217 14.2388 27.8137 13.6117 27.0427 13.3975C25.6341 13 19.9998 13 19.9998 13C19.9998 13 14.3657 13 12.9571 13.3825C12.2009 13.5964 11.5781 14.2389 11.3707 15.0342C11 16.487 11 19.5 11 19.5C11 19.5 11 22.5282 11.3707 23.9658C11.5783 24.7611 12.1861 25.3882 12.9572 25.6023C14.3805 26 20 26 20 26C20 26 25.6341 26 27.0427 25.6175C27.8138 25.4035 28.4217 24.7764 28.6294 23.9811C28.9999 22.5282 28.9999 19.5153 28.9999 19.5153C28.9999 19.5153 29.0148 16.487 28.6291 15.0342ZM18.2059 22.2835V16.7165L22.8912 19.5L18.2059 22.2835Z","fill":"white","key":1})]);
}

YoutubeInline.defaultProps = {"width":"45","height":"45","viewBox":"0 0 40 40","fill":"none"};

module.exports = YoutubeInline;

YoutubeInline.default = YoutubeInline;
